import { render, staticRenderFns } from "./FormCourseAliases.vue?vue&type=template&id=64193848&"
import script from "./FormCourseAliases.vue?vue&type=script&lang=js&"
export * from "./FormCourseAliases.vue?vue&type=script&lang=js&"
import style0 from "./FormCourseAliases.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports